import styled, { css } from 'styled-components';

import {
  IconRegularChevronRight,
  ProductSliderPlaceholder,
  breakpoints,
  theme,
} from '@notino/react-styleguide';

import { CdnImage } from '@components/CdnImage';

export const Chevron = styled(IconRegularChevronRight)`
  color: ${theme.color.icon.tertiary};
  height: 1.25rem;
  width: 1.25rem;
`;

export const Wrapper = styled.div`
  padding: 0.75rem;
  background: ${theme.color.background.secondary};
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;

  &:hover {
    background: ${theme.color.background.secondaryHover};
  }
`;

export const DiscoverSetsText = styled.div`
  color: ${theme.color.text.secondary};
  flex: 1;
  ${theme.typography.labelRegular400}
`;

export const StyledCdnImage = styled(CdnImage)`
  height: 3rem;
  width: 3rem;
  object-fit: contain;
  mix-blend-mode: multiply;
`;

export const ImagePlaceholder = styled.div`
  height: 3rem;
  width: 3rem;
`;

export const Title = styled.div`
  ${theme.typography.labelLarge}
  text-align: center;
  @media (min-width: ${breakpoints.md}) {
    ${theme.typography.titleLarge}
  }
`;

export const SliderWrapper = styled.div<{ centerSlider: boolean }>`
  margin: 1.25rem 0 0.25rem;

  [data-testid='phone-slider'] {
    padding: 0 1.25rem 2rem;

    ${({ centerSlider }) =>
      centerSlider &&
      css`
        justify-content: center;
      `}
  }

  @media (min-width: ${breakpoints.md}) {
    margin: 2.25rem 0 2rem;

    ${({ centerSlider }) =>
      centerSlider &&
      css`
        [data-testid='desktop-slider'] > div {
          justify-content: center;
        }
      `}
  }
`;

export const StyledLoadingPlaceholder = styled(ProductSliderPlaceholder)<{
  center: boolean;
}>`
  margin: 1.25rem 0 2.25rem;

  @media (min-width: ${breakpoints.md}) {
    margin: 2.25rem 0 2rem;
  }

  ${({ center }) =>
    center &&
    css`
      justify-content: center;
    `}
`;
